export default __webpack_public_path__ + "static/media/fourth.4082cb5b.jpg";